import { useState } from 'react';

import { useQuery } from '@apollo/client';
import { MultiSelect, MultiSelectChangeEvent } from 'primereact/multiselect';

import { GET_YARDS_MULTISELECT } from '@/types.gql';

interface IYardsMultiSelectProps {
  className?: string;
  label?: string;
  value: string[];
  onChange: (yards: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  appendTo?: HTMLElement | null;
}

export const YardsMultiSelect = ({
  className,
  label,
  value,
  onChange,
  disabled = false,
  placeholder = 'Select yards',
  appendTo,
}: IYardsMultiSelectProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const yards = useQuery(GET_YARDS_MULTISELECT, {
    variables: {
      where: {
        or: [
          { id: { in: value } },
          ...(searchTerm ? [{ name: { contains: searchTerm } }] : []),
        ],
      },
    },
  });

  const handleFilter = (event: { filter: string }) => {
    setSearchTerm(event.filter.toLowerCase());
  };

  const handleChange = (e: MultiSelectChangeEvent) => {
    onChange?.(e.value);
  };

  return (
    <div className={`yards-multi-select ${className || ''}`}>
      {label && <label className="mb-2 block">{label}</label>}
      <MultiSelect
        value={value}
        options={yards.data?.yards?.items ?? []}
        onChange={handleChange}
        optionLabel="name"
        optionValue="id"
        filter
        filterPlaceholder="Search yards..."
        onFilter={handleFilter}
        placeholder={placeholder}
        disabled={disabled}
        className="w-full"
        display="chip"
        appendTo={appendTo}
      />
    </div>
  );
};
